import * as React from 'react';
import { GuestVouchersModal } from './GuestVouchersModal';

interface Props {
    reservationId: string;
}

export const GuestVouchersToolButton: React.FC<Props> = ({ reservationId }) => {
    const [showModal, setShowModal] = React.useState(false);

    return (
        <>
            <button
                className="btn btn-outline-contrast"
                onClick={() => setShowModal(true)}
            >
                <i className="fa-solid fa-ticket me-1"></i>
                Program Vouchers
            </button>
            {showModal && (
                <GuestVouchersModal
                    reservationId={reservationId}
                    onClose={() => setShowModal(false)}
                />
            )}
        </>
    );
};
